import { defineComponent as _defineComponent } from 'vue'
import { useGtm } from '@gtm-support/vue2-gtm';
import {
  computed,
  onMounted, ref, watch,
} from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'DirtyModalZalando',
  props: {
  targetShopName: {
    type: String,
    default: undefined,
  },
  targetShopSlug: {
    type: RegExp,
    default: undefined,
  },
  requiredValue: {
    type: Number,
    default: undefined,
  },
  bonusValue: {
    type: Number,
    default: undefined,
  },
},
  setup(__props) {

const props = __props

const form = store.state.customer?.form;



// Google Tag Manager
const gtm = useGtm();

// Google Tag Manager Event
function triggerGtmEvent(event: string): void {
  gtm?.trackEvent({
    event,
    campaignName: 'Zalando',
  });
}

// Vue Router
const route = useRoute();
const router = useRouter();

const modal = ref(false);
const getLocale = computed(() => store.getters.getLocale);

const zalandoImageFileName = computed(() => `zalando-${getLocale.value}`);

const title = computed(() =>
//  return 'Nur im ${(new Date())?.toLocaleString?.('de', { month: 'long' })}!`
  '');

const yes = () => {
  modal.value = false;
  form.redeemStartingPoint = { source: 'popup', campaignName: 'Zalando' };

  triggerGtmEvent('advertismentPopupAccepted');
  if (props.targetShopSlug) {
    const targetShop = store.getters.getShopWall
      .find((shop: { slug: string }) => props.targetShopSlug.test(shop.slug));

    router.push({
      name: 'shopDetails',
      params: {
        id: String(targetShop?.id),
        slug: String(targetShop?.slug),
      },
      query: {
        utm_campaign: `${props.targetShopName}-redeem-banner`,
      },
    });
  }
};

const no = () => {
  modal.value = false;
};

onMounted(() => {
  setTimeout(() => {
    if (route.name !== 'shopDetails') {
      modal.value = true;
    }
  }, 250);
});

watch(modal, (val) => {
  if (val === false) {
    triggerGtmEvent('advertismentPopupDeclined');
  }
});

return { __sfc: true,form, props, gtm, triggerGtmEvent, route, router, modal, getLocale, zalandoImageFileName, title, yes, no }
}

})